import { put, call, delay } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import {
    FETCH_LEADERBOARD_DATA,
    POLL_LEADERBOARD_DATA,
    removeLeaderboardDataRequest,
    setLeaderboardData,
    setLeaderboardDataRequest
} from '../actions';

/**
 * @typedef {object} FetchLeaderboardDataAction
 * @property {object} payload
 * @property {string} [payload.year]
 */

/**
 * @param {FetchLeaderboardDataAction} action - The Redux action.
 */
export function* fetchLeaderboardData(action) {
    const { year } = action.payload;

    yield put(setLeaderboardDataRequest(action.payload));

    // Fetch data
    let data = yield call(
        fetchWithMisToken,
        `${PULSE.app.environment.cfsApi}/draft/year/${year}`
    );

    if (data) {
        yield put(setLeaderboardData({ year, data }));
        // trigger poll if there are draft picks still available
        const selections = data.year?.draftFeeds?.[0]?.selections;
        const lastPick = selections?.length
            ? selections[selections.length - 1]
            : null;

        if (!lastPick?.drafteeId && !lastPick?.passed) {
            yield put(POLL_LEADERBOARD_DATA.request({ year }));
        }
    } else {
        // Error handling for when there is no data
        yield put(
            setLeaderboardData({
                year,
                error: 'no data available'
            })
        );
    }

    yield put(removeLeaderboardDataRequest(action.payload));

    yield put(FETCH_LEADERBOARD_DATA.success(data));
}

/**
 * @param action
 */
export function* pollMatchByMatchData(action) {
    const { year } = action.payload;

    yield delay(PULSE.app.common.CONSTANTS.MATCH_POLL_DELAY);
    // Fire API call
    yield put(FETCH_LEADERBOARD_DATA.request({ year }));
}
